/* amaflow: Suchzeile auf dem Handy beim Scrollen ausblenden
 *
 * Die Kopfzeile klebt oben und ist mit Suchfeld rund 149 px hoch - das ist auf
 * einem Telefon fast ein Fuenftel des Bildschirms. Beim Herunterscrollen wird
 * die Suchzeile deshalb eingeklappt und beim Hochscrollen wieder gezeigt.
 *
 * Gegen Flackern wirken drei Dinge:
 *
 * 1. Pufferzone: Die Richtung muss eine Strecke am Stueck gehalten werden,
 *    bevor umgeschaltet wird. Einzelne Gegenbewegungen beim Daumenwischen
 *    setzen den Zaehler nur zurueck.
 * 2. Sperre nach dem Umschalten: Das Ein- und Ausklappen aendert die Hoehe der
 *    klebenden Kopfzeile um 64 px. Der Browser verschiebt dabei die
 *    Scrollposition, was wie eine Gegenbewegung aussieht - ohne Sperre klappt
 *    es sofort wieder zurueck.
 * 3. Ruhe ganz oben und waehrend der Eingabe.
 */
(function () {
  var PUFFER_AUS = 48; /* so weit muss man am Stueck nach unten, zum Ausblenden */
  var PUFFER_AN = 32; /* so weit nach oben, zum Wiedereinblenden */
  var SPERRE_MS = 350; /* etwas laenger als die CSS-Animation (250 ms) */
  var AB_HIER = 120; /* ganz oben bleibt die Suche immer sichtbar */
  var KLASSE = 'mm-suche-aus';

  var schmal = window.matchMedia('(max-width: 749px)');
  var letzte = window.pageYOffset || 0;
  var summe = 0;
  var gesperrtBis = 0;
  var wartet = false;

  function suchfeldAktiv() {
    var a = document.activeElement;
    return !!(a && a.closest && a.closest('.header__search'));
  }

  function umschalten(aus) {
    if (document.body.classList.contains(KLASSE) === aus) return;
    document.body.classList.toggle(KLASSE, aus);
    gesperrtBis = Date.now() + SPERRE_MS;
    summe = 0;
  }

  function pruefen() {
    wartet = false;
    var jetzt = window.pageYOffset || 0;
    var weg = jetzt - letzte;
    letzte = jetzt;

    if (!schmal.matches) {
      document.body.classList.remove(KLASSE);
      return;
    }
    /* Waehrend der Animation nichts bewerten - die Hoehenaenderung der
       Kopfzeile erzeugt selbst eine scheinbare Gegenbewegung. */
    if (Date.now() < gesperrtBis) {
      summe = 0;
      return;
    }
    if (jetzt <= AB_HIER || suchfeldAktiv()) {
      umschalten(false);
      return;
    }

    /* Richtungswechsel setzt den Zaehler zurueck. */
    if ((weg > 0) !== (summe > 0)) summe = 0;
    summe += weg;

    if (summe >= PUFFER_AUS) umschalten(true);
    else if (summe <= -PUFFER_AN) umschalten(false);
  }

  function beiScroll() {
    if (wartet) return;
    wartet = true;
    window.requestAnimationFrame(pruefen);
  }

  window.addEventListener('scroll', beiScroll, { passive: true });
  document.addEventListener('focusin', function () {
    if (suchfeldAktiv()) umschalten(false);
  });
  if (schmal.addEventListener) schmal.addEventListener('change', pruefen);
})();
